<div class="my-3 w-full flex-col">
  <h1 class="mat-display-1 qaroni-title mb-1 w-full text-center leading-none">
    <ng-content select="[title]" />
  </h1>

  <h2 class="qaroni-subtitle mb-1 w-full text-center">
    <ng-content select="[subtitle]" />
  </h2>
</div>
